module.exports = __webpack_public_path__ + "static/media/knife-kitchen.5cddbd3b.svg";